// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*全局样式*/
* {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", "Helvetica", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "SimSun", "sans-serif";
}
img {
  border: 0;
}
/*链接*/
a {
  color: #333333;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
/*vue看模拟body，每一个template下面的第一个div的class为body，login.vue不算在内*/
.body {
  margin: 0;
  padding: 10px;
  font-size: 12px;
  line-height: 24px;
}
/*清除浮动样式*/
.clear {
  clear: both;
  overflow: hidden;
  margin: 0;
  padding: 0;
  width: 0;
  height: 0;
}
/*分隔行*/
.separate {
  clear: both;
  overflow: hidden;
  margin: 0;
  padding: 0;
  width: 10px;
  height: 10px;
  font-size: 10px;
}
/*分隔线*/
.line {
  clear: both;
  overflow: hidden;
  margin: 0 auto;
  padding: 0;
  width: 1px;
  height: 1px;
  background: #ebeef5;
}
/*表格*/
.tb {
  width: 100%;
  border: 1px solid #ebeef5;
  border-collapse: collapse;
  background: white;
  font-size: 12px;
  line-height: 30px;
}
.tb tr.even {
  background: #fbfdff;
}
.tb th {
  padding: 2px 10px;
  line-height: 34px;
  text-align: left;
  font-weight: bold;
  color: #606266;
  border: 1px solid #ebeef5;
  border-bottom: 1px solid #d7e2f7;
  background: #f5f8fd;
}
.tb th.checkbox,
.tb td.checkbox {
  width: 20px;
  text-align: center;
}
.tb td {
  padding: 2px 10px;
  line-height: 34px;
  text-align: left;
  color: #303133;
  border: 1px dashed #f2f2f2;
}
.tb td.fixtd {
  padding: 10px;
  vertical-align: top;
}
.tb td a {
  color: #ff4b13;
  text-decoration: none;
}
.tb td a:hover {
  text-decoration: underline;
}
.tb td.label {
  width: 100px;
  text-align: right;
  color: #606266;
}
.tb td.op {
  padding: 12px 10px;
  text-align: center;
  border-top: 1px solid #ebeef5;
  background: white;
}
.highlight {
  color: #ff4b13;
}
/*区块*/
.box {
  border: 1px solid #e3e3e3;
  background: white;
}
.fixbox {
  padding: 10px;
}
/*查询条件与列表对齐*/
.fixbox > .el-form {
  padding: 0 10px;
}
/* element-ui 全局样式样正 */
div.body * {
  font-size: 12px;
}
/*修正el-table样式，表头背景，表格行距*/
table thead tr th {
  color: #606266 !important;
  border-bottom: 1px solid #d7e2f7 !important;
  background: #f5f8fd !important;
}
table tbody td {
  color: #303133 !important;
}
/* 强制表格单元格英文/数字长串换行 */
.el-table .cell {
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
}
/* 表格内输入框：默认无下边距，无错误时极致紧凑、顶部对齐、错误提示时自动向下换行 */
.el-table .el-form-item {
  margin-bottom: 0 !important;
}
.el-table .el-table__cell:has(.el-form-item) {
  vertical-align: top !important;
  overflow: visible !important;
  padding: 8px 0 !important;
}
.el-table .el-form-item__error {
  word-break: break-all !important;
  word-wrap: break-word !important;
  white-space: normal !important;
  position: relative !important;
}
/*修正nprogress进度条颜色*/
#nprogress .bar {
  background: #ff4b13 !important;
}
/*修正el-dialog*/
.el-dialog * {
  font-size: 12px;
}
.el-dialog__headerbtn > .el-dialog__close {
  font-weight: bold;
  color: #303133;
}
.el-dialog > .el-dialog__header > .el-dialog__title {
  font-weight: bold;
}
.el-dialog__body {
  padding: 5px 20px 10px 20px;
}
/*修正el-tree标签文字过长不能显示横向流动条，高亮当前选中的树节点*/
.el-tree > .el-tree-node {
  min-width: 100%;
  display: inline-block;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #ff4b13;
}
/*修正el-drawer*/
.el-drawer__header {
  margin-bottom: 5px;
  font-weight: bold;
  color: #303133;
}
.el-drawer__close-btn .el-icon-close {
  font-weight: bold;
  color: #303133;
}
.el-drawer__close-btn .el-icon-close:hover {
  color: #409EFF;
}
.el-drawer__body > .footer {
  margin-top: 20px;
  padding: 10px;
  text-align: right;
}
/*修正下拉框：100%宽度，与文本输入框同宽*/
.el-select,
.el-cascader {
  width: 100%;
}
/*修正引用iconfont（阿里巴巴矢量图标管理）的大小，与element-ui中的icon保持一致*/
.iconmenu {
  font-size: 14px;
}
.iconfont {
  font-size: 13px;
}
/*表单中动态表示*/
.el-form-item-label {
  box-sizing: border-box;
  float: left;
  padding: 0 12px 0 0;
  width: 100px;
  text-align: right;
  vertical-align: middle;
  color: #606266;
}
.el-form-item-content {
  box-sizing: border-box;
  overflow: hidden;
  /* 触发BFC，确保宽度正确 */
  color: #606266;
}
/*页面布局宽度：box form*/
.width-800 {
  width: 800px;
}
.width-1000 {
  width: 1000px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
